/** @format */

export interface SKUDetails {
  AddtoCartAvailable: string;
  AvailableForPickup: string;
  AvailableInStore: string;
  AvailabletoShip: string;
  BOPISAvailable: string;
  ISAAvailable: string;
  ProductSKU: string;
  SKUCurrentPrice: string;
  SKUListPrice: string;
  ShipClass: string;
  WebActiveDate: string;
  WarrantyEligible: boolean;
  attributes: Array<{ Type: string; Value: string }>;
}
